import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import { translate, downloadFile, formatData, enumText } from '../../../../utils/util';
import { Breadcrumbs, Button, Input, ListPagination, Select, SelectItem } from '../../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { ENUMS } from '../../../../utils/constants';
import PickingService from '../../../../services/PickingService';

const TDReport = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [instanceM, setInstanceM] = useState();
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(
        {
            allOrders: true,
            isFinished: true,
            orderType: ENUMS.eOrderType.LinePicking.value,
            orderCode: undefined,
            finishDateStart: undefined,
            finishDateEnd: undefined,
            startedBy: undefined,
            status: undefined
        });

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        return () => {
            setData([]);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.orders?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData([...props.orders.items]);
            } else {
                setData((prevState) => ([...prevState, ...props.orders.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [props.orders?.items, props.orders]);

    useEffect(() => {
        if (currentPage > 0) {
            onFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);



    const onFilter = (click) => {
        var currentPageList = currentPage;
        if (validateInputsRequired("formsReport")) {
            if (click) {
                currentPageList = 0;
                setCurrentPage(0);
            }
            props.getOrders(filter, {
                PageSize: 25,
                PageIndex: currentPageList
            }, () => {
                instanceM[1].close();
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onChangeSelectItem = (event) => {
        filter.startedBy = event;
    };

    const downloadCsv = () => {
        props.getReportTdCsv(filter, (data) => {
            downloadFile(data, `TDReport${Date.now()}.csv`, "data:text/csv", true);
        });
    }

    const getStatus = (value) => translate(`expedition:${enumText(ENUMS.eOrderStatus, value)}`);

    return (
        <div>
            <Breadcrumbs id="reportTitle" title={{ icon: "mdi mdi-archive-search-outline", label: translate('expedition:picking.tdReport') }} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('expedition:picking.filter')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <div id="formsReport" className="row">
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.finishDateStart}
                                            type="date"
                                            label={translate('change-location:startDate')}
                                            id="finishDateStart"
                                            name="finishDateStart"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.finishDateEnd}
                                            type="date"
                                            label={translate('change-location:endDate')}
                                            id="finishDateEnd"
                                            name="finishDateEnd"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.orderCode}
                                            id="orderCode"
                                            name='orderCode'
                                            label='TD'
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <SelectItem
                                            id="startedBy"
                                            name="startedBy"
                                            value={filter.startedBy}
                                            label={translate('expedition:picking.finishedBy')}
                                            onChange={(event) => onChangeSelectItem(event)}
                                            onChangeData={onChangeSelectItem}
                                            data={props.usersFromElog ? props.usersFromElog.map(item => {
                                                return {
                                                    id: item.id,
                                                    text: item.user
                                                }
                                            }) : []}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s11">
                                        <Select
                                            id="status"
                                            name="status"
                                            display="description"
                                            defaultValue={""}
                                            change={onChange}
                                            placeHolder={`Status - ${translate('general:choose-one-option')}`}
                                            data={[{ id: ENUMS.eOrderStatus.Finished.value, text: translate('expedition:' + ENUMS.eOrderStatus.Finished.text) },
                                            { id: ENUMS.eOrderStatus.Canceled.value, text: translate('expedition:' + ENUMS.eOrderStatus.Canceled.text) }
                                            ]}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button onClick={() => onFilter(true)} full="true" text={translate('delivery:general.search')} />
                                </div>
                            </div>
                        </li>
                    </ul>
                    {
                        data.length > 0 && navigator.userAgent !== 'logisticspwa' &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button onClick={downloadCsv} full="true" text={translate('general.generateReport')} />
                        </div>
                    }
                </div>
                <div id="list">
                    <ListPagination
                        disableRow={true}
                        page={props.orders?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            data.map((item, index) => {
                                return <div className="row" key={`${item.id}-${index}`} style={{ marginBottom: '0px' }}>
                                    <ul className="col s12" style={{ padding: '0', marginTop: '0' }}>
                                        <li
                                            key={`oi-${item.id}-${index + 1}`}
                                            style={{ backgroundColor: 'white', boxShadow: '0 1px 5px 0 rgba(0,0,0,0.2)', padding: '4px' }}
                                        >
                                            <div
                                                className="row"
                                                key={`${item.id}-row${index + 2}`}
                                                style={{ backgroundColor: 'white', color: 'black', padding: '12px', display: 'block', marginBottom: '0px' }}
                                            >

                                                <div className="title black-text col s12" style={{ padding: '0px' }}>{`TD: ${item.orderCode}`}</div>
                                                <div className="col s12" style={{ padding: '0px' }}>{`${translate('expedition:picking.finishedOn')}: ${formatData(item.finishedOn)}`}</div>
                                                <div className="col s12" style={{ padding: '0px' }}>{`${translate('expedition:picking.finishedBy')}: ${item.startedBy}`}</div>
                                                <div className="col s12" style={{ padding: '0px' }}>{`${translate('general:status')}: ${getStatus(item.status)}`}</div>

                                            </div>
                                        </li>
                                    </ul >
                                </div >;
                            })
                        }
                    />
                </div>
            </div>
        </div>
    );
}

const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog),
        orders: state.pickingReducer.orders
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getOrders: (filter, pagination, callback) => {
            dispatch(PickingService.getOrders(filter, pagination, callback));
        },
        getReportTdCsv: (filter, callback) => {
            dispatch(PickingService.getReportTdCsv(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(TDReport)));
